export type ConsentChoice = { analytics: boolean; marketing: boolean; ts: number };

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const CONSENT_HEAD_SCRIPT = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('consent','default',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',analytics_storage:'denied',wait_for_update:500});gtag('set','ads_data_redaction',true);gtag('set','url_passthrough',false);try{var pe=JSON.parse(localStorage.getItem('pe_consent'));if(pe&&typeof pe.analytics==='boolean'&&typeof pe.marketing==='boolean'){gtag('consent','update',{analytics_storage:pe.analytics?'granted':'denied',ad_storage:pe.marketing?'granted':'denied',ad_user_data:pe.marketing?'granted':'denied',ad_personalization:pe.marketing?'granted':'denied'});}}catch(e){}`;

export function readConsent(): ConsentChoice | null {
  try {
    const choice = JSON.parse(localStorage.getItem("pe_consent") || "null");
    if (choice && typeof choice.analytics === "boolean" && typeof choice.marketing === "boolean") {
      return choice;
    }
  } catch { /* Unavailable storage or invalid JSON is treated as no choice. */ }
  return null;
}

export function saveConsent(analytics: boolean, marketing: boolean) {
  const choice: ConsentChoice = { analytics, marketing, ts: Date.now() };
  try { localStorage.setItem("pe_consent", JSON.stringify(choice)); } catch { /* Apply the choice for this visit even if storage is blocked. */ }
  window.gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
  window.dataLayer.push({ event: "consent_update", analytics, marketing });
}

export function openCookieSettings() {
  window.dispatchEvent(new Event("pe:cookie-settings"));
}